module.exports = __webpack_public_path__ + "img/coinbankB42.54a357fd.jpg";